

























































import { checkCron } from '@/libs/util';
import DictMixin from '@/mixins/dict-mixin';
import MenuMixin from '@/mixins/menu-mixin';
import CronjobServices from '@/services/cronjob';
import moment from 'moment';
import { mixins } from 'vue-class-component';
import { Component, Prop } from 'vue-property-decorator';
import JobDetail from './job-detail.vue';
@Component({
  components: { JobDetail }
})
export default class JobList extends mixins(DictMixin, MenuMixin) {
  @Prop() name!: any;
  @Prop() type!: any;
  @Prop() list!: any;

  jobSrv = new CronjobServices();

  date: any = '';

  visible = false;
  visible2 = false;

  get TYPE() {
    return this.type.toUpperCase();
  }

  pagination = { showTotal: () => `共 ${this.list.length} 条` };
  columns = [
    { title: '作业编号', dataIndex: 'jobCode' },
    { title: this.name, dataIndex: 'jobNameEx' },
    {
      title: '最新处理状态',
      dataIndex: 'handleStatus',
      scopedSlots: {
        customRender: 'handleStatus'
      }
    },
    { title: '最新作业处理数据日期', dataIndex: 'handleDataDate' },
    {
      title: '操作',
      dataIndex: 'action',
      width: 320,
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];

  edit: boolean = false;
  detail: any = {};
  async getDetail(record: any) {
    let info = await this.jobSrv.getInfo(record.id);
    this.detail = info;
    this.visible = true;
    this.edit = false;
  }

  async goEdit(record: any) {
    let info = await this.jobSrv.getInfo(record.id);
    this.detail = info;
    this.visible = true;
    this.edit = true;
  }

  async detailConfirm() {
    if (this.edit) {
      let cron = this.detail.cronExpression;
      if (!checkCron(cron)) {
        this.$message.error('cron表达式不正确');
        return false;
      }
      let res = await this.jobSrv.update(this.detail);
      if (res) {
        this.$message.success('操作成功');
        this.visible = false;
      }
    } else {
      this.visible = false;
    }
  }

  batch: boolean = false;
  doRun(record: any) {
    this.detail = record;
    this.visible2 = true;
    this.batch = false;
  }

  routeToRecord(record: any) {
    let { jobGroupName, jobCode } = record;
    this.$router.push(`/jobs/record/${jobGroupName}?jobCode_eq=${jobCode}`);
  }

  async submitBatch() {
    let params = [
      {
        id: this.detail.id,
        jobGroupName: this.detail.jobGroupName,
        type: 3,
        handleDataDate: moment(this.date).format('YYYY-MM-DD')
      }
    ];
    if (this.batch) {
      params = this.selectedRows.map((record: any) => ({
        id: record.id,
        jobGroupName: record.jobGroupName,
        type: 3,
        handleDataDate: moment(this.date).format('YYYY-MM-DD')
      }));
    }
    let res = await this.jobSrv.run(params);
    this.visible2 = false;
    if (res) {
      this.$message.success('操作成功');
      this.selectedRowKeys = [];
      this.$emit('reload');
    }
  }

  selectedRows: any[] = [];
  selectedRowKeys: any[] = [];
  onSelectChange(keys: any, rows: any) {
    this.selectedRowKeys = keys;
    this.selectedRows = rows;
  }
  handleBatch(e: any) {
    if (e.key === 'doRunAll') {
      if (this.selectedRows.length === 0) {
        this.$message.error('请选中至少一条数据');
        return false;
      }
      this.visible2 = true;
      this.batch = true;
    }
  }

  async confirmDelete(record: any) {
    this.$confirm({
      title: '删除确认',
      content: '确定要删除选中的作业吗？',
      okText: '确定',
      cancelText: '取消',
      onOk: async () => {
        let res = await this.jobSrv.remove(record.id);
        if (!res) return false;
        this.$message.success('删除成功');
        this.selectedRowKeys = [];
        this.$emit('reload');
      }
    });
  }

  bodyStyle = { backgroundColor: '#EEE' };
}
